var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-screen',{attrs:{"title":_vm.title,"background":"white","slim":true,"toolbar":"tasks","back":"Categories"}},[_c('com-summary',{attrs:{"total":true}}),_c('div',{staticClass:"tasks-list"},[_c('com-pending'),_c('com-completed')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }